import { Link, useNavigate } from "react-router-dom";

import {
  createStripeAcc,
  createStripeAccLink,
  deleteProduct,
  getAllProductsbyBusiness,
  getStripeAcc,
  getStripeCountries,
} from "../../actions/acc_actions";
import { useQuery } from "@tanstack/react-query";
import Loading from "../../utils/Loading";
import { RxDotsVertical } from "react-icons/rx";
import {
  Button,
  Dropdown,
  Image,
  message,
  Modal,
  Space,
  Typography,
  Input,
  Form,
  Select,
} from "antd";
import { useState } from "react";
import ContentLayout from "../layout/ContentLayout";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { CiCirclePlus } from "react-icons/ci";
import ShopCard from "../ShopCard";
import { useTranslation } from "react-i18next";

const { Text } = Typography;
const { Option } = Select;

export const redirectToStripeAccountLink = async (accountUrn) => {
  try {
    const res = await createStripeAccLink({ accountUrn });
    const url = res?.data?.accountLink?.url;

    if (url) {
      window.location.href = url;
    } else {
      console.error("Stripe account link URL not found");
    }
  } catch (err) {
    console.error("Failed to redirect to Stripe account link:", err);
  }
};

export default function Shop({ accUrn, businessSlug }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const {
    refetch,
    isLoading: productsLoading,
    data: productsData,
  } = useQuery({
    queryKey: ["products", [businessSlug]],
    queryFn: () => getAllProductsbyBusiness(businessSlug),
  });

  if (productsLoading) {
    return <Loading />;
  }

  const products = productsData?.body?.products || [];

  const handleEdit = (productId) => {
    navigate(`${productId}/edit`);
  };

  // ✅ Show confirmation modal before deleting
  const handleDelete = (productId) => {
    Modal.confirm({
      title: "Are you sure you want to delete this product?",
      content: "",
      okText: "Yes, Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk: () => {
        deleteProduct(productId)
          .then(() => {
            message.success("Product deleted successfully!");
            refetch();
          })
          .catch(() => {
            message.error("Failed to delete the product.");
          });
      },
    });
  };

  return (
    <ContentLayout
      header={
        <>
          <h1>
            Welcome to <span> Shop</span>
          </h1>
        </>
      }
    >
      <div className="outlet-cards">
        <Link to="add" className="outlet-add btn">
          <CiCirclePlus size={48} />
          <div className="outlet-add-content">
            <p>Add New </p>
            <h4 className="active">Product</h4>
          </div>
        </Link>

        {products.map((productItem) => (
          <ShopCard
            key={productItem.id}
            product={productItem}
            onEdit={() => handleEdit(productItem.id)}
            onDelete={() => handleDelete(productItem.id)}
          />
        ))}
      </div>
    </ContentLayout>
  );
}
